module.exports = __webpack_public_path__ + "img/tabbar-icon-safety.8e1e558c.png";